import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { PaymentProviderQrDto } from '@model/MasterTransactionDto'

import { DepositProceedValues } from '../hooks/useDepositProceedRedirect'
import { ProceedModalContent } from './components/ProceedModalContent'

interface CryptoPaymentProviderModalProps {
  onProceed(): void
  values: DepositProceedValues
  qr?: PaymentProviderQrDto | null
  transactionId?: string
  onQrSuccess?(): void
  onQrDeclined?(): void
}

export const CryptoPaymentProviderProceedModal: BaseModalType<CryptoPaymentProviderModalProps> = ({
  onProceed,
  values,
  qr,
  transactionId,
  onQrSuccess,
  onQrDeclined,
  close,
}) => {
  const { t } = useTranslation()

  if (!values) return null

  return (
    <ProceedModalContent
      values={values}
      qr={qr}
      transactionId={transactionId}
      onProceed={onProceed}
      close={close}
      onQrSuccess={onQrSuccess}
      onQrDeclined={onQrDeclined}
    >
      <Modal.Body.Text>{t('Crypto address validity')}</Modal.Body.Text>
      <Modal.Body.Text>{t('Crypto address single use')}</Modal.Body.Text>
      <Modal.Body.Text>{t('Crypto address reuse warning')}</Modal.Body.Text>
    </ProceedModalContent>
  )
}
